import s from './PermissionProgress.module.scss';

interface Props {
  enabledCount: number;
  totalRights: number;
}

const SIZE = 48;
const STROKE = 4;
const R = (SIZE - STROKE) / 2;
const CIRC = 2 * Math.PI * R;

export default function PermissionProgress({ enabledCount, totalRights }: Props) {
  const pct = totalRights > 0 ? enabledCount / totalRights : 0;
  const offset = CIRC * (1 - pct);

  return (
    <div className={s.wrap}>
      <svg width={SIZE} height={SIZE} className={s.svg}>
        <circle
          className={s.track}
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={R}
          fill="none"
          strokeWidth={STROKE}
        />
        <circle
          className={s.fill}
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={R}
          fill="none"
          strokeWidth={STROKE}
          strokeDasharray={CIRC}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div className={s.text}>
        <span className={s.count}>
          <strong>{enabledCount}</strong>/{totalRights}
        </span>
        <span className={s.label}>permissions</span>
      </div>
    </div>
  );
}
